import { LOCALE_EN_GB, LOCALE_NL_NL } from '../constants'
import labelsNlNl from './nl-NL.json'
import labelsEnGb from './en-GB.json'

const generalLabelsForLocale = (locale) => {
  switch (locale) {
    case LOCALE_NL_NL:
      return labelsNlNl
    case LOCALE_EN_GB:
      return labelsEnGb
  }
}

export const mergeLabels = (locale, labelsForLocale) => ({
  general: generalLabelsForLocale(locale),
  ...labelsForLocale,
})
